

export default {
  listRegionsDO: [],
  totalRegionDO : 1,
  currentPage : 1,
  per_page : 10
}



// WEBPACK FOOTER //
// ./src/store/products/state.js